'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { MultiColumnSelector } from '../ColumnSelector';
import { useNodeInputColumns } from '../../../hooks/useNodeInputs';
import { Info } from '@phosphor-icons/react';

interface GroupByConfigProps {
  nodeId: string;
  config: { groupBy?: string[] };
}

export function GroupByConfig({ nodeId, config }: GroupByConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [groupBy, setGroupBy] = useState<string[]>(config.groupBy || []);
  const inputColumns = useNodeInputColumns(nodeId);

  const handleChange = (cols: string[]) => {
    setGroupBy(cols);
    updateNodeConfig(nodeId, { type: 'group_by', params: { groupBy: cols } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-xs font-medium text-zinc-500">分组字段</label>
        <MultiColumnSelector values={groupBy} onChange={handleChange} columns={inputColumns} />
      </div>
      <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-xl border border-blue-100">
        <Info className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-xs text-blue-700 font-medium">分组后生成 N 张独立子表</p>
          <p className="text-xs text-blue-600">执行结果区会为每个分组值单独展示一个 Tab。后续节点（筛选、排序、聚合等）将分别作用于每个子表。在末尾接「追加」节点可将所有子表合并回一张表。</p>
        </div>
      </div>
    </div>
  );
}
